export const scripts = [
    // {
    //     name: 'KeenSlider',
    //     src: 'https://cdnjs.cloudflare.com/ajax/libs/keen-js/5.0.5/keen.bundle.js',
    //     include: document.querySelector('.')
    // }
]

export const styles = [
    // {
    //     name: 'KeenSlider',
    //     src: 'https://cdnjs.cloudflare.com/ajax/libs/keen-js/5.0.5/keen.min.css',
    //     include: document.querySelector('.keen-slider')
    // },
]